import React from 'react';
import { clsx } from 'clsx';

const buttonVariants = {
  default: "bg-[#494646] text-white hover:bg-[#151415]/50",
  destructive: "bg-red-500 text-white hover:bg-red-600",
  outline: "border border-slate-600 bg-transparent hover:bg-slate-800 text-slate-300",
  secondary: "bg-slate-800 text-slate-200 hover:bg-slate-700",
  ghost: "hover:bg-[#2a282a] text-slate-300 hover:text-slate-100",
  link: "text-blue-400 underline-offset-4 hover:underline",
  toggle_active:"bg-[#494646] text-white",
  sidebar_button: "hover:bg-[#494646] text-gray-300 hover:text-gray-100",

};

const buttonSizes = {
  default: "h-9 px-3 py-1.5 text-sm",
  sm: "h-7 px-2 py-1 text-xs",
  lg: "h-11 px-6 py-2.5",
  icon: "h-9 w-9"
};

export function Button({
  className,
  variant = "default",
  size = "default",
  children,
  ...props
}) {
  return (
    <button
      className={clsx(
        "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900 disabled:opacity-50 disabled:pointer-events-none",
        buttonVariants[variant],
        buttonSizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}